import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';

import { TOGGLZ_FEATURES } from '@bibliocommons/constants-feature-togglz';
import { bibShape, catalogBibShape } from '@bibliocommons/bc-prop-types';
import { bindActionCreators } from 'redux';
import Context from '@bibliocommons/context';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { selectBibEntities } from 'app/selectors/EntitiesSelector';
import { selectCurrentMovie } from 'app/selectors/MoviesSelector';
import ModalActions from 'app/actions/ModalActions';
import MoviesActions from 'app/actions/MoviesActions';
import MovieTrailer from './MovieTrailer';

export class MovieTrailerContainer extends React.PureComponent {
  componentDidMount() {
    this.fetchMovie();
  }

  fetchMovie() {
    if (this.context.features.get(TOGGLZ_FEATURES.BIB_PAGE_MOVIE_TRAILERS)) {
      const { moviesActions, bib, catalogBib } = this.props;
      const title = catalogBib.getIn(['brief', 'title']);
      const superFormats = bib.getIn(['briefInfo', 'superFormats']);

      if (title && superFormats.includes('MOVIES_TV_VIDEO')) {
        moviesActions.getMovieByTitle(title);
      }
    }
  }

  render() {
    return this.props.movie && <MovieTrailer {...this.props} />;
  }
}

MovieTrailerContainer.propTypes = {
  bib: bibShape.isRequired,
  catalogBib: catalogBibShape.isRequired,
  movie: ImmutablePropTypes.map,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired,
  moviesActions: PropTypes.objectOf(PropTypes.func).isRequired
};

MovieTrailerContainer.contextType = Context;

const mapStateToProps = state => {
  const catalogBib = selectCatalogBib(state);
  const metadataId = catalogBib.get('metadataId');
  const bib = selectBibEntities(state).get(metadataId);
  const movie = selectCurrentMovie(state);
  return { bib, catalogBib, movie };
};

const mapDispatchToProps = dispatch => ({
  modalActions: bindActionCreators(ModalActions, dispatch),
  moviesActions: bindActionCreators(MoviesActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(MovieTrailerContainer);
